﻿import fitvids from 'fitvids';

export default function init() {
    fitvids();
}